import React from "react";
import { capitalize } from "lodash";
import { Tag } from "antd";
import dayjs from "dayjs";
import {
  CheckSquareOutlined,
  FileTextOutlined,
  MailOutlined,
  MessageOutlined,
  PhoneOutlined,
  RiseOutlined,
} from "@ant-design/icons";

export const activityTypeOptions = [
  { value: "task", label: "Task" },
  { value: "call", label: "Call" },
  { value: "letter", label: "Letter" },
  { value: "text", label: "Text" },
  { value: "email", label: "Email" },
  { value: "eval", label: "Eval" },
];

export const activityTypeIcons = {
  task: <CheckSquareOutlined />,
  call: <PhoneOutlined />,
  letter: <FileTextOutlined />,
  text: <MessageOutlined />,
  email: <MailOutlined />,
  eval: <RiseOutlined />,
};

export const activityPriorityColors = {
  low: "blue",
  medium: "orange",
  high: "red",
};

export const activityPriorityRank = { high: 1, medium: 2, low: 3 };

export const renderPriorityTag = (value) =>
  value ? (
    <Tag variant="outlined" color={activityPriorityColors[value] || "default"}>
      {capitalize(value)}
    </Tag>
  ) : null;

export const activityPriorityOptions = ["low", "medium", "high"].map(
  (value) => ({
    value,
    label: renderPriorityTag(value),
  })
);

export const activityStatusLabels = {
  todo: "To-do",
  overdue: "Overdue",
  today: "Today",
  done: "Done",
};

export const activityStatusColors = {
  todo: "blue",
  overdue: "red",
  today: "orange",
  done: "default",
};

export const activityStatusOptions = ["todo", "overdue", "today", "done"].map(
  (value) => ({
    value,
    label: activityStatusLabels[value],
  })
);

export const renderStatusTags = (statuses) =>
  statuses.map((status) => (
    <Tag
      key={status}
      variant="outlined"
      color={activityStatusColors[status] || "default"}
    >
      {activityStatusLabels[status]}
    </Tag>
  ));

export const activityStatusesFor = (activity) => {
  if (!activity) return [];

  const dueAt = activity.due_at ? dayjs(activity.due_at) : null;
  const statuses = [];

  if (!activity.done) statuses.push("todo");
  if (!activity.done && dueAt?.isBefore(dayjs())) statuses.push("overdue");
  if (dueAt?.isSame(dayjs(), "day")) statuses.push("today");
  if (activity.done) statuses.push("done");

  return statuses;
};
